import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { includes } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { CardPreview, ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { CONTACT_NOT_FOUND_ERR_MSG } from 'features/views/contactDetail/constants';

const AdditionalData = ({ additionalData, handleReload, fetchStorePath }) => {
	const ignoreErrorsForContactDetailNotFound = useIgnoreErrorsWhen({
		fetchStorePath,
		attributePath: ['metaData', 'parsedContent', 'message'],
		condition: (value) => includes(CONTACT_NOT_FOUND_ERR_MSG, value),
	});

	return (
		<ComponentLoader
			onReload={handleReload}
			fetchStorePath={fetchStorePath}
			ignoreErrors={ignoreErrorsForContactDetailNotFound}
		>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('contactDetail:additionalDataSubheader')} />
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={3}>
								{additionalData.map((item, index) => (
									<Grid key={index} size={4}>
										<CardPreview title={item.description} text={item.value} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Stack>
			</Paper>
		</ComponentLoader>
	);
};

AdditionalData.propTypes = {
	additionalData: PropTypes.array,
	fetchStorePath: PropTypes.string,
	handleReload: PropTypes.func,
};

export default AdditionalData;
